// 管理员操作日志动作枚举：value 与后端 AdministratorOperationLogService::store 的 action 参数保持一致。
// group 只服务于列表页「操作动作」下拉的分组展示（见下方 operationActionGroups），
// 不参与任何判断；新增 action 时顺手补 group，漏了会归入「其他」而不是从下拉里消失。
export const operationActions = {
  administrator_destroy: { value: 'administrator_destroy', name: '注销账号', group: '账号管理' },
  administrator_restore: { value: 'administrator_restore', name: '还原账号', group: '账号管理' },
  administrator_password_change: { value: 'administrator_password_change', name: '原密码修改', group: '账号管理' },
  administrator_password_change_by_admin: { value: 'administrator_password_change_by_admin', name: '管理员修改密码', group: '账号管理' },
  administrator_password_reset: { value: 'administrator_password_reset', name: '短信重置密码', group: '账号管理' },
  administrator_update: { value: 'administrator_update', name: '修改管理员资料', group: '资料修改' },
  administrator_profile_update: { value: 'administrator_profile_update', name: '修改个人资料', group: '资料修改' },
  administrator_invite_create: { value: 'administrator_invite_create', name: '生成入职邀请', group: '入职流程' },
  administrator_invite_revoke: { value: 'administrator_invite_revoke', name: '撤销入职邀请', group: '入职流程' },
  administrator_onboard_pass: { value: 'administrator_onboard_pass', name: '入职审核通过', group: '入职流程' },
  administrator_onboard_reject: { value: 'administrator_onboard_reject', name: '入职审核驳回', group: '入职流程' },
  administrator_offboard_apply_create: { value: 'administrator_offboard_apply_create', name: '发起离职申请', group: '离职与复职' },
  administrator_offboard_pass: { value: 'administrator_offboard_pass', name: '离职审核通过', group: '离职与复职' },
  administrator_offboard_reject: { value: 'administrator_offboard_reject', name: '离职审核驳回', group: '离职与复职' },
  administrator_rehire: { value: 'administrator_rehire', name: '重新入职', group: '离职与复职' },
  administrator_role_merge_create: { value: 'administrator_role_merge_create', name: '添加门店/薪资', group: '门店与薪资' },
  administrator_role_merge_update: { value: 'administrator_role_merge_update', name: '修改门店/薪资', group: '门店与薪资' },
  administrator_role_merge_destroy: { value: 'administrator_role_merge_destroy', name: '移除门店/薪资', group: '门店与薪资' },
  administrator_wechat_remove_manual: { value: 'administrator_wechat_remove_manual', name: '手动移出企业微信', group: '企业微信' },
  // 以下三个动作由后端自动/重试逻辑记录，缺了会在列表里直接露出英文 action 名
  administrator_wechat_bind_retry: { value: 'administrator_wechat_bind_retry', name: '重试绑定企业微信', group: '企业微信' },
  administrator_wechat_invite_resend: { value: 'administrator_wechat_invite_resend', name: '重发企业微信邀请', group: '企业微信' },
  administrator_offboard_wechat_remove_fail: { value: 'administrator_offboard_wechat_remove_fail', name: '离职移出企业微信失败', group: '企业微信' },
};

// 「操作动作」下拉分组数据：组顺序 = 各分组在枚举里首次出现的顺序，组内顺序 = 声明顺序，
// 想调整展示顺序就改上面的声明顺序，这里不额外维护一份名单（避免两处清单各改一半）。
export const operationActionGroups = (() => {
  const groups = [];
  const indexOfGroup = {};

  Object.values(operationActions).forEach((action) => {
    const name = action.group || '其他';
    if (indexOfGroup[name] === undefined) {
      indexOfGroup[name] = groups.length;
      groups.push({ name, options: [] });
    }
    groups[indexOfGroup[name]].options.push(action);
  });

  return groups;
})();

export function findOperationAction(value) {
  for (const key in operationActions) {
    if (operationActions[key].value === value) return operationActions[key];
  }
  return { value, name: value || '-' };
}
